import type { ThemeState } from '@atlaskit/tokens';
import { themeStringToObject } from '@atlaskit/tokens';

type FinalTheme = Partial<ThemeState> | ThemeState | null;

export const getThemeFromQueryParams = ({ themeState }: { themeState?: string }): FinalTheme =>
	themeState ? themeStringToObject(decodeURIComponent(themeState)) : null;
